export const ReportsEndpoints = {
    generate: () => '/reports/generate',
};
